<script setup lang="ts">
import { AccordionItem, AccordionItemProps, useForwardProps } from 'radix-vue'

const props = defineProps<AccordionItemProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <AccordionItem v-bind="forwarded">
    <slot></slot>
  </AccordionItem>
</template>
